export default {
      id: "icon-pound-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "img/icons.svg#icon-pound",
      toString: function () {
        return this.url;
      }
    }